module.exports = __webpack_public_path__ + "static/media/logout.ec6e78a4.svg";